export default {
  props: {
    color: {
      type: String,
      default: '#979797',
    },
  },
};
